<template>
  <div>
    <!-- 转换 -->
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">基金转换</span>
        <Reback class="row-one-fr" @click.native="rebackOne"></Reback>
      </el-row>
      <div v-show="stepDisplay == '1'" class="margin-t30">
        <el-form :model="transformForm" :rules="transformFormRules" ref="transformFormRef" label-width="110px" label-position="right" class="form-single">
          <el-form-item label="基金名称：">
            <span>{{fundMessage.fundcodename+'（'+this.$parameterConfig.p_fundtype[fundMessage.fundtype]+'）'}}</span>
          </el-form-item>
          <el-form-item label="可转换基金：" prop="name" v-show="!transformFlag">
            <el-select style="width:100%;" v-model="transformForm.name" placeholder="请选择基金" @change="fundChange">
              <el-option v-for="(item,i) in transformLists" :key="i" :label="'['+item.targetfundcode+']'+item.fundname" :value="'['+item.targetfundcode+']'+item.fundname"></el-option>
            </el-select>
          </el-form-item>
          <!--  -->
          <el-form-item v-show="transformFlag" label="转换后基金：" style="margin-bottom: 10px;">
            <span>{{transformForm.name}}</span>
          </el-form-item>
          <el-form-item v-show="transformFlag" label="转换份额：" style="margin-bottom: 10px;">
            <span>{{transformForm.share +'份'}}</span>
          </el-form-item>
          <el-form-item v-show="transformFlag" label="份额大写：" style="margin-bottom: 10px;">
            <span id="capital"></span>
          </el-form-item>
          <el-form-item v-show="transformFlag" label="密码：" prop="pass" :error="errorMsg">
            <el-input class="inputThree" type="password" v-model="transformForm.pass" autoComplete="new-password" show-password></el-input>
            <el-input style="position:fixed;bottom:-9999px;"></el-input>
          </el-form-item>
          <!--  -->
          <el-form-item label="持有份额：" v-show="!transformFlag">
            <span>{{fundMessage.fundvol+'份'}}</span>
          </el-form-item>
          <el-form-item label="冻结份额：" v-show="!transformFlag">
            <span>{{parseFloat(fundMessage.fundfrozenvol).toFixed(2)+'份'}}</span>
          </el-form-item>
          <el-form-item label="可用份额：" v-show="!transformFlag">
            <span>{{fundMessage.availbal+'份'}}</span>
          </el-form-item>
          <el-form-item label="转换份额：" v-show="!transformFlag" prop="share">
            <el-input v-model="transformForm.share" :placeholder="'可转换份额'+max+'份'" @blur="shareBlur">
              <span slot="suffix" class="form-single-suf">份</span>
            </el-input>
            <span class="form-single-all" @click="allClick">全部</span>
            <div v-show="scopeShow" class="el-form-item__error" style="width:500px;">{{'本基金转换范围（最低'+min+'份 当前可用'+max+'份）'}}</div>
          </el-form-item>
          <el-form-item v-show="!transformFlag">
            <div class="margin-t20">
              <el-button type="normal" style="width:175px;" @click="onSubmitOne">确认</el-button>
              <el-button type="cancel" class="fr" @click="rebackOne">返回</el-button>
            </div>
          </el-form-item>
          <el-form-item v-show="transformFlag">
            <div class="margin-t20">
              <el-button type="normal" style="width:175px;" @click="onSubmitTwo">{{purchaseText}}</el-button>
              <el-button type="cancel" class="fr" @click="rebackTwo">返回</el-button>
            </div>
          </el-form-item>
        </el-form>
        <!-- 说明 -->
        <div class="instruction-li">
          <p class="instruction-li-title margin-t70">温馨提示</p>
          <p class="instruction-li-con">
            当天交易申请至下午15:00:00截止，下午15:00:00以后的申请和非交易日申请将作为下一个工作日的申请处理。<br>
            转换费 = 转出赎回费+转入申购补差费； 实际费用以基金公司确认为准。<br>
            转入申购补差费: 转入基金折扣前申购费超过转出基金折扣前申购费的部分进行补差。
          </p>
        </div>
      </div>
      <!-- 转换成功 -->
      <div v-show="stepDisplay == '2'">
        <div class="modelBox">
          <div class="modelBoxImg">
            <img src="../../../assets/images/20210316_bigdg.png" alt="">
            <p class="modelBoxTip">申请已受理</p>
          </div>
          <!-- 步骤 -->
          <ul class="step">
            <li class="step_li">
              <img src="../../../assets/images/time.png" alt="">
              <span>{{'预计'+successMessage.expectcfmdate+successMessage.expectcfmworkday+'24:00前完成转换'}}</span>
            </li>
          </ul>
          <section class="xDetail">
            <hr class="xDetail-hr">
            <div class="xDetail-switch clearfix margin-t15">
              <span class="xDetail-switch-fl">{{successMessage.fundname}}</span>
              <div class="xDetail-switch-cen">转换为</div>
              <span class="xDetail-switch-fl">{{successMessage.targetfundname}}</span>
            </div>
            <ul class="xDetail-ul margin-t20">
              <li class="xDetail-ul-li"><span>转出份额</span><span>{{successMessage.applicationvol+'份'}}</span></li>
            </ul>
            <hr class="xDetail-hr">
            <ul class="xDetail-ul">
              <li class="xDetail-ul-li"><span>订单编号</span><span>{{successMessage.appsheetserialno}}</span></li>
            </ul>
            <div class="xDetail-footer">
              <el-button type="normal" @click="rebackOne">确定</el-button>
            </div>
          </section>
        </div>
      </div>
      <!-- 转换失败 -->
      <div v-show="stepDisplay == '3'">
        <div class="modelBox">
          <div class="modelBoxImg">
            <img src="../../../assets/images/hbb/error_20210309.png" alt="">
            <p class="modelBoxTip" style="color:#ED0000">转换失败</p>
          </div>
          <p style="margin:40px 0 10px 0;">失败原因</p>
          <p style="line-height: 24px;">{{'目标基金（'+successMessage.fundcode+'）状态未处于正常或权益等级或红利发放或者停止赎回状态，不允许转换！'}}</p>
          <section class="xDetail">
            <hr class="xDetail-hr">
            <div class="xDetail-switch clearfix margin-t15">
              <span class="xDetail-switch-fl">{{successMessage.fundname}}</span>
              <div class="xDetail-switch-cen">转换为</div>
              <span class="xDetail-switch-fl">{{successMessage.targetfundname}}</span>
            </div>
            <ul class="xDetail-ul margin-t20">
              <li class="xDetail-ul-li"><span>转出份额</span><span>{{successMessage.applicationvol+'份'}}</span></li>
            </ul>
            <hr class="xDetail-hr">
            <ul class="xDetail-ul">
              <li class="xDetail-ul-li"><span>订单编号</span><span>{{successMessage.appsheetserialno}}</span></li>
            </ul>
            <div class="xDetail-footer">
              <el-button type="normal" @click="rebackOne">确定</el-button>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- 完善信息 -->
    <Perfect></Perfect>
    <!-- 风险测评 -->
    <RiskTips @func="getFunc"></RiskTips>
  </div>
</template>

<script>
export default {
  data () {
    const isNum = (rule, value, callback) => {
      const ret = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value < this.min - 0) {
        callback(new Error('本基金最低赎回份额是' + this.min + '份，请重新填写！或联系客服400-818-8000进行操作'))
      } else if (value > this.max - 0) {
        callback(new Error('赎回份额超过最大可用份额，请重新输入'))
      } else if (!ret.test(value)) {
        callback(new Error('赎回份额小数点位数不应超过2位，请重新填写！'))
      } else {
        callback()
      }
    }
    return {
      stepDisplay: '1',
      transformForm: {
        name: '',
        share: '',
        pass: '',

      },
      scopeShow: true,
      transformFormRules: {
        name: [
          { required: true, message: '请选择转换基金', trigger: 'change' },
        ],
        share: [
          { required: true, message: '请输入转换份额', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],

      },
      passForm: {
        pass: '',

      },
      passFormRules: {

      },
      purchaseText: '确认',
      errorMsg: '',
      successMessage: '',
      fundMessage: '',
      min: '',
      max: '',
      transformFlag: false,
      transformLists: [],
      targetFundcode: '',
      transactorname: '',
      transactorcerttype: '',
      transactorcertno: '',

    }
  },
  created () {
    this.fundMessage = this.$route.params.fundMessage
    // console.log(this.fundMessage);
  },
  mounted () {
    this.getData()
    this.getTransformFunds()
    this.getFundListone()
  },
  methods: {
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    onSubmitOne () {
      this.transformFormRules.pass[0].required = false
      this.$refs.transformFormRef.validate(valid => {
        if (!valid) {
          this.shareBlur()
        } else {
          this.transformFlag = true
          this.$commonJs.applicationamountinfo(this.transformForm.share, 'capital')
          this.transformFormRules.pass[0].required = true
        }
      })
    },
    rebackOne () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    onSubmitTwo () {
      this.transformFormRules.pass[0].required = true
      this.$refs.transformFormRef.validate(valid => {
        if (!valid) return
        this.purchaseText = '确认中...'
        this.$http.post(this.$apiPath.changeFund, {
          sessionId: this.$commonJs.getCookie('sessionid'),
          tano: this.fundMessage.tano,
          passwd: this.$des.enString(this.transformForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
          targetfundcode: this.targetFundcode,//
          branchcode: '308',
          transactionaccountid: this.fundMessage.transactionaccountid,
          fundcode: this.fundMessage.fundcode,
          applicationamount: this.transformForm.share,
          vastredeemflag: '0',
          buyflag: '0',
          transactorname: this.transactorname,
          transactorcerttype: this.transactorcerttype,
          transactorcertno: this.transactorcertno,
        }).then(res => {
          if (res.status !== 200) return
          // console.log(res);
          if (res.data.code == "10000005") {
            // 密码输入错误
            this.errorMsg = res.data.message
            this.purchaseText = '确认'
          } else if (res.data.code == "9999") {
            // 操作频繁
            this.errorMsg = res.data.message
            this.purchaseText = '确认'
          } else if (res.data.code == "2004") {
            // 假期暂停
            this.$message.success(res.data.message)
            // this.errorMsg = res.data.message
            this.purchaseText = '确认'
          } else if (res.data.code == "2000") {
            // 停止转换
            this.$message.error(res.data.data.ret_msg)
            this.purchaseText = '确认'
          } else if (res.data.code == "200") {
            const result = res.data.data
            this.purchaseText = '确认'
            this.stepDisplay = '2'
            this.getqeryPublicTradesByNo(result.appsheetserial[0].appsheetserialno)
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 12,
              fundname: this.fundMessage.fundcodename,
              money: this.transformForm.share,
              dtDate: "",
              fundname2: this.transformForm.name.split("]")[1]
            })
          } else {
            this.$message.error(res.data.data.ret_msg)
            this.purchaseText = '确认'
          }

        }).catch(err => { })
      })
    },
    // 订单结果
    getqeryPublicTradesByNo (appsheetserialno) {
      this.$http.post(this.$apiPath.qeryPublicTradesByNoNew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: appsheetserialno,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.publicRecord.length > 0)
          this.successMessage = result.publicRecord[0]


      }).catch(error => { })
    },
    rebackTwo () {
      this.transformFlag = false
    },
    // 转换基金列表
    getTransformFunds () {
      this.$http.post(this.$apiPath.queryChangedFund, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        sharetype: this.fundMessage.sharetype,//shareclasses
        fundcode: this.fundMessage.fundcode,
        tano: this.fundMessage.tano,
      }).then(res => {
        // console.log(res);
        this.transformLists = res.data.data.changeFundList[0]
      }).catch(err => { })
    },
    // 获取单只基金信息
    getFundListone () {
      this.$http.post(this.$apiPath.fundListone, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundMessage.fundcode
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.length > 0) {
          this.min = result[0].per_min_24
          this.max = result[0].per_max_24
          if (Number(this.fundMessage.availbal) < Number(this.min)) {//基金份额小于最小份额
            if (Number(this.fundMessage.fundvol) < Number(this.min)) {
              this.min = this.min
              this.max = this.fundMessage.fundvol
            } else {
              this.min = this.min
              this.max = this.fundMessage.fundvol
            }
          } else if (Number(this.fundMessage.availbal) > Number(this.max)) {//基金份额超过最大份额
            this.min = this.min
            this.max = result[0].per_max_24
          } else {
            this.min = result[0].per_min_36
            this.max = Number(this.fundMessage.availbal).toFixed(2);

          }
          this.transformForm.share = this.max
        }
      })
    },
    fundChange (val) {
      // console.log(val.substr(1, 6));
      this.targetFundcode = val.substr(1, 6)
    },
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const userResult = res.data.data.custInfo
        this.f = userResult.transactorname == null ? '' : userResult.transactorname
        this.transactorcerttype = userResult.transactorcerttype == null ? '' : userResult.transactorcerttype
        this.transactorcertno = userResult.transactorcertno == null ? '' : userResult.transactorcertno
      }).catch(error => { })
    },
    allClick () {
      this.transformForm.share = this.fundMessage.availbal
      this.shareBlur()
    },
    shareBlur () {
      this.$refs.transformFormRef.validateField('share', (err) => {
        this.scopeShow = err != '' ? false : true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.modelBox {
  margin: 0 auto;
  width: 400px;
  overflow: hidden;
  .modelBoxImg {
    height: 90px;
    text-align: center;
    margin-top: 50px;
    .modelBoxTip {
      color: #246ead;
      font-size: 22px;
      font-weight: bold;
      margin-top: 20px;
    }
  }
}
.step {
  width: 300px;
  margin: 36px auto;
  &_li {
    position: relative;
    // height: 20px;
    line-height: 20px;
    margin-bottom: 22px;
    text-align: center;
    img {
      margin-right: 8px;
    }
  }
  &_li:last-child {
    margin: 0;
  }
}
</style>